<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-scadenzari page-operative-data-analysis-scadenzari-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo scadenzario</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.scadenzari' }">Torna alla lista</app-router-link>
      </div>

      <FormFinanziamento @saved="saveScadenzario" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-finanziamenti-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormFinanziamento: () => import('../../../../components/Operative/Form/FormFinanziamento'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveScadenzario (scadenzario) {
      this.$api.addScadenzario(this.company.id, scadenzario)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.scadenzari',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
